'use client';

import { motion, Variants } from 'framer-motion';
import Link from 'next/link';

import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { ShortDarkLogo } from '@components/common/logo';
import { Routes } from '@lib/routes';

const variants: Variants = {
  visible: {
    opacity: 1,
  },
  hidden: {
    opacity: 0,
  },
};

export function LowerHeaderShortLogo() {
  const searchExpanded = useHeaderStore((state) => state.searchExpanded);

  return (
    <motion.div
      variants={variants}
      initial='hidden'
      exit='hidden'
      animate={searchExpanded ? 'visible' : 'hidden'}
      transition={{ duration: 0.2 }}
      style={{ transformStyle: 'preserve-3d' }}
      className='lg:hidden'
    >
      <Link href={Routes.root} className='flex-shrink-0'>
        <span className='sr-only'>Upcyclers</span>
        <ShortDarkLogo />
      </Link>
    </motion.div>
  );
}
